// 316680977911132226  预警消息
// 326751636439720020  采购寻源
// 326751771282399259  合同协同
// 326751856057671708  交易协同
// 326751966783103064  结算协同
// 326752076254437422  账单协同
// 326752196886814736  资金往来
// 326752284195446839  发票协同
// 336633715558236173  协同单位
// 336633807501574183  物资管理
export const MESSAGE_IMG_MAP = {
    316680977911132226: 'warning.png',
    326751636439720020: 'purchase.png',
    326751771282399259: 'contract.png',
    326751856057671708: 'trade.png',
    326751966783103064: 'settle.png',
    326752076254437422: 'bil.png',
    326752196886814736: 'fund.png',
    326752284195446839: 'invoice.png',
    336633715558236173: 'unit.png',
    336633807501574183: 'material.png',
};
